"use client";

import {Container} from "@/shared/components/shared";
import React, {ChangeEvent, useState} from "react";
import Image from "next/image";
import {Button} from "@/shared/components/ui/button";
import MasonryCollage from "@/shared/components/ui/masonry-collage";
import {useRouter} from "next/navigation";
import UniversalBookingModal from "@/shared/components/ui/universal-booking-modal";

const formatDate = (datetime: string) => {
    const date = new Date(datetime);
    const day = date.getDate();
    const month = date.getMonth();

    const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];

    return `${day} ${months[month]}`;
};

const events = [
    { datetime: '2024-11-29T10:00:00', title: 'Toyota Prado Land Cruser' },
    { datetime: '2024-12-06T10:00:00', title: 'Rav 4 Harrier' },
    { datetime: '2024-12-13T10:00:00', title: 'Nissan Juke  |  Nissan x-trail' },
    { datetime: '2024-12-14T10:00:00', title: 'Toyota Lexus' },
];


export default function ScheduleAutofest() {
    const router = useRouter();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [name, setName] = useState('');
    const [brand, setBrand] = useState('');
    const [isUniversalBookingOpen, setIsUniversalBookingOpen] = useState(false);

    const getInputNumbersValue = (input: HTMLInputElement) => {
        return input.value.replace(/\D/g, '');
    }

    const onPhonePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        let input = e.currentTarget,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData('Text');
            if (/\D/g.test(pastedText)) {
                input.value = inputNumbersValue;
                return;
            }
        }
    }

    const onPhoneInput = (e: React.FormEvent<HTMLInputElement>) => {
        let input = e.currentTarget,
            inputNumbersValue = getInputNumbersValue(input),
            selectionStart = input.selectionStart || 0,
            formattedInputValue = "";

        if (!inputNumbersValue) {
            return input.value = "";
        }

        if (input.value.length != selectionStart) {
            const event = e.nativeEvent as InputEvent;
            if (event.data && /\D/g.test(event.data)) {
                input.value = inputNumbersValue;
            }
            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] == "9") inputNumbersValue = "7" + inputNumbersValue;
            let firstSymbols  = (inputNumbersValue[0] == "8") ? "8" : "+7";
            formattedInputValue = input.value = firstSymbols + " ";
            if (inputNumbersValue.length > 1) {
                formattedInputValue += '(' + inputNumbersValue.substring(1, 4);
            }
            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ') ' + inputNumbersValue.substring(4, 7);
            }
            if (inputNumbersValue.length >= 8) {
                formattedInputValue += '-' + inputNumbersValue.substring(7, 9);
            }
            if (inputNumbersValue.length >= 10) {
                formattedInputValue += '-' + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = '+' + inputNumbersValue.substring(0, 16);
        }
        input.value = formattedInputValue;
        setPhoneNumber(formattedInputValue);
    }

    const onPhoneKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        let input = e.currentTarget;
        let inputValue = input.value.replace(/\D/g, '');
        if (e.keyCode == 8 && inputValue.length == 1) {
            input.value = "";
        }
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsUniversalBookingOpen(true);
    };

    return (
        <>
            <section className={'mt-[89px]'}>
                <Container className={'pt-12 pb-21 lg:pt-31 lg:pb-32'}>
                    <div className={'flex items-start justify-between gap-4'}>
                        <h1 className={'uppercase font-bold text-[30px] lg:text-[70px] leading-[1.2] text-custom-black flex-1'}>
                            расписание <span className={'text-custom-orange'}>фестивалей</span>
                        </h1>
                        <button
                            onClick={() => router.push('/autofest')}
                            className="flex-shrink-0 cursor-pointer hover:opacity-70 transition-opacity self-start"
                            aria-label="Закрыть"
                        >
                            <svg 
                                width="40" 
                                height="40" 
                                viewBox="0 0 40 40" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                                className={'w-10 h-10 lg:w-16 lg:h-16'}
                            >
                                <path 
                                    d="M10 10L30 30M30 10L10 30" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round"
                                    className="text-custom-light-gray"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className={'mt-5 lg:mt-39'}>
                        {events.map((event, index) => (
                            <div key={index} className="text-[18px] lg:text-[45px] leading-[1.2] uppercase mb-2 lg:mb-9">
                                <span className="date font-bold">{formatDate(event.datetime)}</span>
                                <span className="title"> - {event.title}</span>
                            </div>
                        ))}
                    </div>
                    <div className={'flex flex-col lg:flex-row justify-between mt-17 lg:mt-39'}>
                        <div className={'max-w-[468px]'}>
                            <h3 className={'text-[24px] lg:text-[48px] leading-[1.1] font-bold'}>Вашего автомобиля нет в списке AutoFest?</h3>
                            <p className={'text-[24px] leading-[1.1] mt-5'}>Оставьте заявку на вашу марку номер телефона. И мы обязательно добавим автодень и сообщим вам об этом</p>
                        </div>
                        <form className={'flex flex-col mt-11 lg:mt-0 lg:ml-13'} onSubmit={handleSubmit}>
                            <input name="car"
                                   value={brand}
                                   onChange={(e) => setBrand(e.target.value)}
                                   required
                                   className={'border-1 border-custom-ig pt-3 lg:pt-4 pb-3 lg:pb-4 pl-6 lg:pl-8 pr-6 lg:pr-8 rounded-[5px] text-[18px] lg:text-2xl leading-[1.1] focus:border-custom-light-orange outline-hidden'}
                                   placeholder={'Марка'}
                            />
                            <input name="name"
                                   value={name}
                                   onChange={(e) => setName(e.target.value)}
                                   required
                                   className={'border-1 border-custom-ig pt-3 lg:pt-4 pb-3 lg:pb-4 pl-6 lg:pl-8 pr-6 lg:pr-8 mt-3 lg:mt-5 rounded-[5px] text-[18px] lg:text-2xl leading-[1.1] focus:border-custom-light-orange outline-hidden'}
                                   placeholder={'Ваше имя'}
                            />
                            <input name="phone"
                                   required
                                   className={'border-1 border-custom-ig pt-3 lg:pt-4 pb-3 lg:pb-4 pl-6 lg:pl-8 pr-6 lg:pr-8 mt-3 lg:mt-5 rounded-[5px] text-[18px] lg:text-2xl leading-[1.1] focus:border-custom-light-orange outline-hidden'}
                                   placeholder={'+7 (000) 000-00-00'}
                                   value={phoneNumber}
                                   onChange={(e) => onPhoneInput(e)}
                                   onPaste={onPhonePaste}
                                   onKeyDown={onPhoneKeyDown}
                            />
                            <Button variant={'filledOrange'} type={"submit"}
                                    className={'pt-2 lg:pt-5 pb-2 lg:pb-5 pl-12 lg:pl-44 pr-12 lg:pr-44 font-button leading-none mt-4 lg:mt-9 text-[16px]'}>
                                отправить заявку
                            </Button>
                        </form>
                    </div>
                </Container>
            </section>
            <UniversalBookingModal isOpen={isUniversalBookingOpen} onClose={() => setIsUniversalBookingOpen(false)} blockName="Расписание фестивалей"/>
        </>
    );
};